import {addQueryToPath} from '../../../../../../libs/shared/core/src/helpers/browser/urlHelpers';
import {ApiArticle} from '../../../../../../libs/shared/core/src/models/api/knowledgeBaseArticleModel';
import {KnowledgeBaseSupportedLanguagesTypesEnum} from '../../../../../../libs/shared/core/src/models/api/knowledgeBaseModel';
import {fetchApiAsync} from '../../../../../../libs/shared/core/src/services/http/http';
import {buildAppQueries} from '../../../../../../libs/shared/core/src/services/query/appQueryHelpers';

/*
 * Query.
 */

export const knowledgeBaseReportArticleQueries = buildAppQueries('knowledgeBaseReportArticle', {
  byId: (id: number, locale?: KnowledgeBaseSupportedLanguagesTypesEnum) => ({
    queryKey: {id},
    queryFn: async ({company, cancelToken}) =>
      fetchApiAsync(
        ApiArticle,
        addQueryToPath(`${company.url}/articles/${encodeURIComponent(id)}`, {locale}),
        {
          cancelToken,
        },
      ),
  }),
});
